import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useAuth } from '../context/AuthContext';
import { logConfig } from '../utils/logger';
import config from '../config.json';

import AuthPage from './AuthPage';
import GymMap from './GymMap';
import AuthCallback from './AuthCallback';

const App = () => {
  const { isAuthenticated, loading } = useAuth();

  // Log configuration on startup
  useEffect(() => {
    document.title = config.page_title;
    logConfig(config);
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="app-container">
        <ToastContainer position="top-right" autoClose={5000} />
        <Routes>
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/map"
            element={isAuthenticated ? <GymMap /> : <Navigate to="/login" />}
          />
          <Route
            path="/login"
            element={!isAuthenticated ? <AuthPage /> : <Navigate to="/map" />}
          />
          <Route path="/" element={<Navigate to={isAuthenticated ? "/map" : "/login"} />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;